export class Answer {

  value: number;

  constructor(value: number) {
    this.value = value;
  }

}
